var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatsDown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    transform: "matrix(1 0 0 -1 1 23)",
    fill: "#F7D5D5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 15V12.5L16.6295 13.8705L15.5 15H18Z",
    fill: "#E75C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 9L10.0667 13.6154L12.4 10.3846L16.6295 13.8705M16.6295 13.8705L18 15M16.6295 13.8705L18 12.5V15M16.6295 13.8705L15.5 15H18",
    stroke: "#E75C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsDown);
export default __webpack_public_path__ + "static/media/stats-down.dfa47b72f5c4230aa4f5d618d6768dee.svg";
export { ForwardRef as ReactComponent };